<template>
  <div class="million-read-user-work">
    <div class="million-read-user-work-header">
      <header-back-btn />
      <span class="title">{{ render.pageTitle }}</span>
      <ym-icon class="share-icon"
               name="mr-share"
      />
    </div>
    <div v-if="list.length !== 0"
         class="million-read-user-work-list"
    >
      <work-item v-for="(item, index) in list"
                 :key="index"
                 :item="item"
                 :curr-user-id="userId"
                 location="workList"
      />
    </div>
    <empty-page v-else
                type="million-read"
                :hint="emptyHint"
    />
  </div>
</template>

<script>
  import { HeaderBackBtn } from '@ymba/ym-ui';
  import WorkItem from '@/pages/MillionReadUserCenter/components/WorkItem';
  import EmptyPage from '@/components/EmptyPage';
  import { getUserWorkExplore } from '@/services/million-read';
  import { isAppWebView } from '@/utils';
  import { LIMIT } from '@/utils/constant';

  export default {
    name: 'MillionReadUserWork',
    metaInfo: {},
    components: {
      HeaderBackBtn,
      WorkItem,
      EmptyPage,
    },
    data() {
      return {
        start: 0,
        allLoad: false,
        list: [],
        render: {
          pageTitle: '',
        },
      };
    },
    computed: {
      inAppWebView() {
        return isAppWebView();
      },
      userId() {
        const { $route } = this;
        return $route.query && $route.query.userId ? parseInt($route.query.userId, 10) : 0;
      },
      emptyHint() {
        return this.allLoad ? '该同学暂无作品' : '正在加载数据';
      },
    },
    methods: {
      async getWorkList() {
        if (this.allLoad) return;
        const params = {
          start: this.start,
          limit: LIMIT,
          userId: this.userId,
        };
        const data = await getUserWorkExplore(params);
        this.render = data.render;

        if (data.list.length === 0) {
          this.allLoad = true;
          return;
        }
        this.list = data.list;
        this.start = data.start;

        this.getWorkList();
      },
    },
    created() {
      this.getWorkList();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .million-read-user-work {
    box-sizing: border-box;
    min-height: 100%;
    background: @color-white;

    &-header {
      box-sizing: border-box;
      width: 100%;
      height: 88px;
      padding: 0 @size-base;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: @color-text-base;
      .title {
        font-size: @font-size-large;
        font-weight: @font-weight-strong;
      }
      .share-icon {
        font-size: @font-size-extra-large;
      }
    }
    &-list {
      box-sizing: border-box;
      padding: 48px @size-base 100px @size-base;
    }
  }

</style>
